import { MatDialog } from '@angular/material/dialog';
import { LimitDialogComponent } from './components/limit-dialog/limit-dialog.component';
import { LegacyDialogComponent, LegacyDialogEnum } from './components/legacy-dialog/legacy-dialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SaveBookmarkDialogComponent, SaveBookmarkDialogMode } from './components/save-bookmark-dialog/save-bookmark-dialog.component';
import { GroupRestrictionDialogComponent } from './components/group-restriction-dialog/group-restriction-dialog.component';
import { ClipboardDialogComponent } from './components/clipboard-dialog/clipboard-dialog.component';
import { WelcomeTourDialogComponent, WelcomeTourEnum } from './components/welcome-tour-dialog/welcome-tour-dialog.component';
import { DomainJoinDialogComponent } from './components/domain-join-dialog/domain-join-dialog.component';
import { AboutDialogComponent } from './components/about-dialog/about-dialog.component';
import { SaveModuleDialogComponent } from './components/save-module-dialog/save-module-dialog.component';
import { NpsDialogComponent } from './components/nps-dialog/nps-dialog.component';
import { ImportModelDialogComponent } from './components/import-model-dialog/import-model-dialog.component';
import { AddTeamModelDialogComponent } from './components/add-team-model-dialog/add-team-model-dialog.component';
import { DialogIds } from './models/dialog-ids';
import { BackgroundColorDialogComponent } from './components/background-color-dialog/background-color-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/dialog";
const mobileScreenWidth = 768;
const transparentDialogCSSClass = 'backdropClass';
export class DialogService {
    constructor(dialog) {
        this.dialog = dialog;
    }
    get isMobile() {
        return window.innerWidth <= mobileScreenWidth;
    }
    openClipboardDialog(copyText, config) {
        const options = Object.assign({ data: {
                id: DialogIds.ClipboardDialog,
                copyText: copyText
            } }, config);
        return this.dialog.open(ClipboardDialogComponent, options);
    }
    openWelcomeTourDialog(tourVersion, config) {
        const userType = tourVersion === 'updated_tour' ? WelcomeTourEnum.ExistingUser : WelcomeTourEnum.NewUser;
        const options = Object.assign({ id: DialogIds.WelcomeTourDialog, disableClose: true, data: {
                userType: userType
            } }, config);
        return this.dialog.open(WelcomeTourDialogComponent, options);
    }
    openJoinDomainDialog(organization, config) {
        const options = Object.assign({ id: DialogIds.JoinDomainDialog, data: {
                organization: organization
            } }, config);
        return this.dialog.open(DomainJoinDialogComponent, options);
    }
    openNpsSurveyDialog(surveyGroupName, config) {
        const options = Object.assign({ id: DialogIds.NpsSurveyDialog, data: {
                surveyGroupName: surveyGroupName
            } }, config);
        return this.dialog.open(NpsDialogComponent, options);
    }
    openConfirmDialog(config) {
        const options = Object.assign({ id: DialogIds.ConfirmDialog }, config);
        return this.dialog.open(ConfirmDialogComponent, options);
    }
    openLimitDialog() {
        this.dialog.closeAll();
        return this.dialog.open(LimitDialogComponent, {
            id: DialogIds.LimitDialog,
            width: '480px'
        });
    }
    openUpgradeDialog(config) {
        const dimensions = {
            width: 925,
            height: 700
        };
        const options = Object.assign({ id: DialogIds.UpgradeDialog }, {
            width: `${dimensions.width}px`,
            height: `${dimensions.height}px`,
            data: {
                type: LegacyDialogEnum.UpgradeSubscription,
                dimensions: dimensions
            }
        }, config);
        this.dialog.closeAll();
        return this.dialog.open(LegacyDialogComponent, options);
    }
    openBuyDialog(config) {
        const dimensions = {
            width: 550,
            height: 650
        };
        const options = Object.assign({ id: DialogIds.BuyDialog }, {
            width: `${dimensions.width}px`,
            height: `${dimensions.height}px`,
            data: {
                type: LegacyDialogEnum.BuySubscription,
                dimensions: dimensions
            }
        }, config);
        this.dialog.closeAll();
        return this.dialog.open(LegacyDialogComponent, options);
    }
    openProfileDialog(config, tab = '') {
        const dimensions = {
            width: 750,
            height: 600
        };
        const options = Object.assign({ id: DialogIds.ProfileDialog }, {
            width: `${dimensions.width}px`,
            height: `${dimensions.height}px`,
            data: {
                type: LegacyDialogEnum.MyProfile,
                dimensions: dimensions,
                options: {
                    show_tab: tab
                }
            }
        }, config);
        this.dialog.closeAll();
        return this.dialog.open(LegacyDialogComponent, options);
    }
    openSaveModuleDialog(id, config) {
        this.dialog.closeAll();
        const options = Object.assign({ id: DialogIds.SaveModuleDialog }, {
            width: '480px',
            data: {
                id: id
            }
        }, config);
        return this.dialog.open(SaveModuleDialogComponent, options);
    }
    openSaveBookmarkDialog(bookmark, config) {
        return this._openSaveBookmarkDialog(Object.assign({ id: DialogIds.SaveBookmarkDialog, data: {
                bookmark: bookmark,
                mode: SaveBookmarkDialogMode.SaveStory
            } }, config));
    }
    openSaveAsBookmarkDialog(title, bookmarkTitle, message, config) {
        return this._openSaveBookmarkDialog(Object.assign({ id: DialogIds.SaveBookmarkDialog, data: {
                title: title,
                bookmarkTitle: bookmarkTitle,
                message: message,
                mode: SaveBookmarkDialogMode.SaveStory
            } }, config));
    }
    openManageDialog(bookmark, config) {
        return this._openSaveBookmarkDialog(Object.assign({ id: DialogIds.SaveBookmarkDialog, data: {
                bookmark: bookmark,
                mode: SaveBookmarkDialogMode.Manage
            } }, config));
    }
    openBookmarkAccessDialog(bookmark, config) {
        const options = Object.assign({ id: DialogIds.BookmarkAccessDialog, width: '480px', data: {
                model: bookmark
            } }, config);
        this.dialog.closeAll();
        return this.dialog.open(SaveBookmarkDialogComponent, options);
    }
    openGroupRestrictionDialog(config) {
        const options = Object.assign({ id: DialogIds.GroupRestrictionDialog }, {
            width: '480px',
            height: 'auto'
        }, config);
        return this.dialog.open(GroupRestrictionDialogComponent, options);
    }
    openPremiumContentDialog() {
        const bodyText = this.isMobile
            ? 'This is premium content. Visit us on desktop to upgrade to a premium plan.'
            : 'This is premium content. Upgrade to a Premium Plan for unlimited access.';
        return this.openConfirmDialog({
            id: DialogIds.PremiumContentDialog,
            data: {
                titleText: 'Premium Content',
                bodyText: bodyText,
                confirmText: 'Go Premium',
                confirmEnabled: !this.isMobile,
                cancelText: 'OK',
                confirmColor: 'warn'
            }
        });
    }
    openAboutDialog() {
        this.dialog.closeAll();
        return this.dialog.open(AboutDialogComponent, {
            id: DialogIds.AboutDialog
        });
    }
    openImportDialog() {
        this.dialog.closeAll();
        const options = {
            id: DialogIds.ImportDialog,
            maxWidth: '90vw',
            width: '90vw',
            height: '90vh'
        };
        return this.dialog.open(ImportModelDialogComponent, options);
    }
    openAddTeamModelDialog(bookmark) {
        const options = {
            id: DialogIds.AddTeamModelDialog,
            data: {
                bookmark: bookmark
            }
        };
        return this.dialog.open(AddTeamModelDialogComponent, options);
    }
    openBackgroundColorDialog() {
        const options = {
            backdropClass: transparentDialogCSSClass,
            data: {}
        };
        return this.dialog.open(BackgroundColorDialogComponent, options);
    }
    _openSaveBookmarkDialog(config) {
        const options = Object.assign({ mode: SaveBookmarkDialogMode.SaveStory }, config);
        this.dialog.closeAll();
        return this.dialog.open(SaveBookmarkDialogComponent, options);
    }
}
DialogService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DialogService_Factory() { return new DialogService(i0.ɵɵinject(i1.MatDialog)); }, token: DialogService, providedIn: "root" });
